/*
 * @Description:
 * @Author: 刘宝顺
 * @Date: 2024-03-25 17:15:32
 * @LastEditTime: 2024-03-25 17:16:39
 * @LastEditors: 刘宝顺
 */
/** 解析url参数 */
export function getURLParameters(url: string = window.location.href): object {
    // 获取URL中的查询字符串部分
    const queryString = url.split('?')[1];

    // 如果没有查询字符串，返回空对象
    if (!queryString) {
        return {};
    }

    // 将查询字符串拆分为参数对
    const parameterPairs = queryString.split('&');

    // 创建一个对象来存储参数
    const parameters = {};

    // 遍历参数对，并将它们添加到对象中
    parameterPairs.forEach((pair) => {
        const [key, value] = pair.split('=');
        // 对URL解码以处理特殊字符
        parameters[key] = decodeURIComponent(value);
    });

    return parameters;
}

/** 检测设备类型 */
export function detectDevice(): 'Android' | 'iOS' {
    const { userAgent } = navigator;

    if (/Android/i.exec(userAgent)) {
        return 'Android';
    } else if (/iPhone|iPad/i.exec(userAgent)) {
        return 'iOS';
    }
    return 'Android';
}
